import { TFunction } from 'i18next';
import { ema, ma } from 'moving-averages';

import { MAType } from '../../../reducers/preference.reducer';
import { PriceDataPoint } from '../../../types';
import {
  DataSetSeriesGenerator,
  getDefaultToolptipFormatter,
  PriceViewerSeries,
} from './base';
import { fillPriceDates } from './utils';

/**
 * Naive SMA implementation, we should optimize it using moving window algorithm.
 */

class MA extends DataSetSeriesGenerator {
  windowSize: number;
  type: MAType;
  isSeparateFromPriceChart = false;
  shareYAxisWithPriceChart = true;

  constructor(type: MAType, windowSize: number, t: TFunction) {
    super(t);
    this.type = type;
    this.windowSize = windowSize;
  }

  getChartName(): string {
    return `${this.type.toUpperCase()}-${this.windowSize}`;
  }

  getColor(windowSize: number): string {
    switch (windowSize) {
      case 250: {
        return '#3ba272';
      }
      case 50: {
        return '#73c0de';
      }
      case 20: {
        return '#ef6666';
      }
      case 10: {
        return '#fac858';
      }
      default: {
        return '#808080';
      }
    }
  }

  getSeries(dataPoints: ReadonlyArray<PriceDataPoint>): PriceViewerSeries {
    const maFunction = this.type === 'sma' ? ma : ema;

    const allDates = dataPoints.map(item => item.date.toString());
    const dataPointsWithData = dataPoints.filter(
      ({ close }) => close !== undefined
    );
    const dates = dataPointsWithData.map(({ date }) => date) as string[];
    const closePrices = dataPointsWithData.map(({ close }) => close);
    const mas: number[] = maFunction(closePrices, this.windowSize).map(item =>
      // only display 2 decimal places
      item === undefined ? undefined : Number(item)
    );

    const color = this.getColor(this.windowSize);

    return {
      name: this.getChartName(),
      echartSeries: {
        type: 'line',
        data: fillPriceDates(allDates, mas, dates),
        symbol: 'none',
        lineStyle: {
          opacity: 0.5,
          color,
        },
      },
      legendColor: color,
      legendFormat: 'float',
      tooltipFormatter: getDefaultToolptipFormatter('2d', 'number', {
        keyColor: color,
      }),
    };
  }
}

export default MA;
